import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';

const Header = ({ cartItemCount }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  return (
    <header className="header">
      {/* Top Bar */}
      <div className="header-topbar">
        <div className="container">
          <div className="topbar-content">
            <div className="topbar-left">
              <span className="topbar-item">
                <div className="contact-info-icon">
                  <i className="fas fa-phone"></i>
                </div>
                <a href="tel:+911234567890">+91 1141254770</a>
              </span>
              <span className="topbar-item">
                <div className="contact-info-icon">
                  <i className="fas fa-envelope"></i>
                </div>
                <a href="mailto:gadelectricalindustries@gmail.com"> gadelectricalindustries@gmail.com</a>
              </span>
              <span className="topbar-item">
                <div className="contact-info-icon">
                  <i className="fas fa-clock"></i>
                </div>
                Mon–Sat: 9:00 AM – 6:00 PM
              </span>
            </div>
            <div className="topbar-right">
              <a href="https://www.linkedin.com/company/g.a.d.-electrical-industries/" target="_blank" rel="noreferrer" className="social-link" aria-label="LinkedIn">in</a>
            </div>
          </div>
        </div>
      </div>

      {/* Main Header */}
      <div className="header-main">
        <div className="container">
          <div className="header-content">
            <img className='logo-img' src='/logo.png' alt="G.A.D. Logo" />
            <Link to="/" className="logo">
              <span className="logo-icon">
              </span>
              <div className="logo-text-group">
                <span className="logo-text">G.A.D.</span>
                <span className="logo-tagline">Electrical Industries</span>
              </div>
            </Link>

            <button
              className={`mobile-menu-btn ${isMenuOpen ? 'open' : ''}`}
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              aria-label="Toggle menu"
            >
              <span></span>
              <span></span>
              <span></span>
            </button>

            <nav className={`nav ${isMenuOpen ? 'nav-open' : ''}`}>
              <Link to="/" className={isActive('/') ? 'active' : ''} onClick={() => setIsMenuOpen(false)}>Home</Link>
              <Link to="/about" className={isActive('/about') ? 'active' : ''} onClick={() => setIsMenuOpen(false)}>About Us</Link>
              <Link to="/products" className={isActive('/products') ? 'active' : ''} onClick={() => setIsMenuOpen(false)}>Products</Link>
              <Link to="/contact" className={isActive('/contact') ? 'active' : ''} onClick={() => setIsMenuOpen(false)}>Contact</Link>

            </nav>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
